import React from 'react';
import { Avatar } from 'antd';
import { initials } from '../../utils/initials';
import { avatarColor } from '../../utils/avatarColor';

interface Props {
  name: string;
  logoUrl: string | null;
  size?: number;
}

export const LogoOrInitials: React.FC<Props> = ({ name, logoUrl, size = 64 }) => {
  const bg = avatarColor(name);
  return (
    <Avatar
      src={logoUrl ?? undefined}
      size={size}
      style={{
        flexShrink: 0,
        background: logoUrl
          ? undefined
          : `linear-gradient(135deg, ${bg} 0%, ${bg}cc 100%)`,
        color: '#ffffff',
        fontWeight: 700,
        fontSize: size * 0.35,
      }}
    >
      {logoUrl ? undefined : initials(name)}
    </Avatar>
  );
};
